import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import isEmpty from 'lodash/isEmpty'
import { Button } from 'reactstrap'

import withAuthorization from '../higherOrder/withAuthorization'

import { PLANTS } from '../../constants/routes'
import { addSensor, startAddPlantToSensor } from '../../actions'
import { ThreeBounceSpinner } from '../Global/LoadingSpinner'
import { LoadingWrapper } from '../StyledComponents/Classifier/LoadingScreen'
import { FillerDiv, CenteredDivWithMargin } from '../StyledComponents/Fillers'
import { InputText } from '../StyledComponents/Pages/Intro'
import LoadingOverlay from '../Global/LoadingOverlay'

class IntroPage extends Component {
    constructor(props) {
        super(props)

        // TODO: add user defined image upload
        this.state = {
            uuid: '',
            name: '',
            loading: false,
        }

        this.saveClicked = this.saveClicked.bind(this)
        this.uuidChanged = this.uuidChanged.bind(this)
        this.nameChanged = this.nameChanged.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const { devices, sessionState } = nextProps
        const { mode, history } = this.props
        const { loading } = this.state
        const { sensorId } = mode.data

        if (loading && !!sensorId && !!devices[sensorId]) {
            if (!!sessionState.authUser && !!sessionState.idToken) {
                this.setState({ loading: false })
                history.push(PLANTS)
            }
        }
    }

    saveClicked() {
        const {
            sessionState, add, startAddPlant,
        } = this.props
        const {
            uuid, name,
        } = this.state

        if (!!sessionState && !!sessionState.authUser && !!sessionState.idToken) {
            const { token } = sessionState.idToken
            add(token, uuid, name)
            startAddPlant(uuid)
            this.setState({ loading: true })
        }
    }

    uuidChanged(e) {
        const { value } = e.currentTarget

        this.setState({
            uuid: value,
        })
    }

    nameChanged(e) {
        const newValue = e.currentTarget.value

        this.setState({
            name: newValue,
        })
    }

    render() {
        const {
            name, uuid, loading,
        } = this.state

        const { sessionState } = this.props

        if (!sessionState || !sessionState.authUser || !sessionState.idToken) {
            return (
                <LoadingWrapper>
                    <ThreeBounceSpinner />
                </LoadingWrapper>
            )
        }

        const loadingOverlay = loading
            ? <LoadingOverlay />
            : null

        return (
            <FillerDiv>
                {loadingOverlay}
                <CenteredDivWithMargin fontSize="1.4rem" top="10" left="20" right="20">
                    {'Um den Sensor hinzuzufügen, brauchen wir ein paar Infos!'}
                    <br />
                    <br />
                    {'Wie lautet die Sensor UUID?'}
                </CenteredDivWithMargin>
                <CenteredDivWithMargin top="20" left="10" right="10" bottom="30">
                    <InputText type="text" placeholder="Sensor UUID" value={uuid} onChange={this.uuidChanged} />
                    <CenteredDivWithMargin fontSize="1.4rem" top="30" left="20" right="20" bottom="10">
                        {'Gebe dem Sensor einen Namen:'}
                    </CenteredDivWithMargin>
                    <InputText type="text" placeholder="Sensor Name" value={name} onChange={this.nameChanged} />
                    <br />
                    <Button color="info" onClick={this.saveClicked} disabled={isEmpty(name) || isEmpty(uuid)}>Weiter</Button>
                </CenteredDivWithMargin>
            </FillerDiv>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    sessionState: state.sessionState,
    devices: state.devices,
    mode: state.mode,
})

export default compose(
    withAuthorization(authCondition),
    withRouter,
    connect(mapStateToProps, {
        add: addSensor,
        startAddPlant: startAddPlantToSensor,
    })
)(IntroPage)



// WEBPACK FOOTER //
// ./src/components/pages/AddSensor.js